import axiosInstance from "../../../utils/axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import { AxiosError } from "axios";
import { IConsentsResponse } from "../../../models/Interface/User.interface";
import { useAppQuery } from "../../querys/useAppQuery";

const useUserConsents = (userId: string | undefined) => {
  const { data, isLoading, isError, error, refetch, isFetching, isPending } =
    useAppQuery<IConsentsResponse, AxiosError<IErrorResponse>>({
      queryKey: [QueryKeys.USER_CONSENTS, { userId }],
      queryFn: async () => {
        return (
          await axiosInstance.get(`/users-consents/${userId}`)
        ).data;
      },
      enabled: !!userId,
      retry: 0,
    });

  return { data, isLoading, isError, error, refetch, isFetching, isPending };
};

export default useUserConsents;
